var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          style: { width: "90%", backgroundColor: "#eae9e9" },
          attrs: {
            position: "right",
            "close-on-click-overlay": false,
            round: "",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择合同",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: { "click-left": _vm.close, "click-right": _vm.popupSubmit },
          }),
          _c("van-search", {
            attrs: { "show-action": "", clearable: "", shape: "round" },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.queryParams.contractName,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "contractName", $$v)
              },
              expression: "queryParams.contractName",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-70", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c(
                    "van-pull-refresh",
                    {
                      on: { refresh: _vm.onRefresh },
                      model: {
                        value: _vm.refreshing,
                        callback: function ($$v) {
                          _vm.refreshing = $$v
                        },
                        expression: "refreshing",
                      },
                    },
                    [
                      _c(
                        "van-list",
                        {
                          staticClass: "p-l-20 p-r-20 p-b-20",
                          attrs: {
                            "immediate-check": false,
                            error: _vm.error,
                            finished: _vm.finished,
                            "finished-text": "没有更多了",
                          },
                          on: {
                            "update:error": function ($event) {
                              _vm.error = $event
                            },
                            load: _vm.getList,
                          },
                          model: {
                            value: _vm.loading,
                            callback: function ($$v) {
                              _vm.loading = $$v
                            },
                            expression: "loading",
                          },
                        },
                        _vm._l(_vm.list, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "bg-FF p-20 m-t-20 b-r-10",
                              style: {
                                border: item.activated
                                  ? "3px solid #F8B91A"
                                  : "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.change(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex col-center row-between" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 font-30 cor-3E3A39 font-weight-600",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.contractName) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-30",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("合同金额(万元)")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.reserveLength(
                                                Number(item.contractAmount)
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("项目名称")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.projectName) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("客户")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.customerCompanyName) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              item.contractTime
                                ? _c(
                                    "van-row",
                                    {
                                      staticClass: "m-t-10",
                                      attrs: { type: "flex", align: "center" },
                                    },
                                    [
                                      _c("van-col", { attrs: { span: "10" } }, [
                                        _c(
                                          "div",
                                          { staticClass: "cor-88 font-30" },
                                          [_vm._v("签订日期")]
                                        ),
                                      ]),
                                      _c("van-col", { attrs: { span: "14" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cor-33 font-30 van-multi-ellipsis--l3",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm
                                                    .moment(item.contractTime)
                                                    .format("YYYY-MM-DD")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }